import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Header.css";
import { FaTwitter, FaDiscord } from "react-icons/fa";
import { UserContext } from "../context/UserContext"; // اتصال به کانتکست
import logo from "../logo.MP4"

function Header() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { user, setUser } = useContext(UserContext); // دریافت اطلاعات و تابع به‌روزرسانی از کانتکست

  useEffect(() => {
    const token = localStorage.getItem("userToken");

    if (token) {
      fetch(`${API_BASE_URL}/User/profile`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        .then((data) => {
          const userData = {
            username: data.username,
            avatar:
              `${API_BASE_URL}` + data.imageAddress ||
              "https://images.unsplash.com/photo-1488161628813-04466f872be2?fm=jpg&q=60&w=3000",
            admin: data.isAdmin,
          };
          setUser(userData); // ذخیره اطلاعات در کانتکست
        })
        .catch((err) => {
          console.error("خطا در دریافت اطلاعات کاربر:", err);
          setUser(null);
        });
    } else {
      setUser(null);
    }
  }, [setUser]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <nav className="nav-bar">
        {/* ✅ لوگو */}
        <div className="nav-left">
          <Link to="/" className="logo-container">
            <video
              src={logo}
              autoPlay
              muted
              loop
              playsInline
              className="logo-video"
            />
          </Link>
        </div>

        {/* ✅ دکمه‌ی منوی موبایل */}
        <div className="menu-icon" onClick={toggleMenu}>
          ☰
        </div>

        {/* ✅ منو */}
        <ul className={`nav-list ${isOpen ? "active" : ""}`}>
          {/* ✅ نمایش پروفایل در موبایل */}
          <div className="mobile-user-profile">
            {user ? (
              <>
                <img src={user.avatar} alt="User Avatar" className="user-avatar" />
                <Link to="/setting" onClick={toggleMenu} className={location.pathname === "/setting" ? "active-link" : ""}>
                  {user.username}
                </Link>
              </>
            ) : (
              <Link to="/login" onClick={toggleMenu} className="auth-btn">
                Register / Login
              </Link>
            )}
          </div>

          {/* ✅ لینک‌های منو */}
          <li><Link to="/" onClick={toggleMenu} className={location.pathname === "/" ? "active-link" : ""}>Home</Link></li>
          <li><Link to="/utility" onClick={toggleMenu} className={location.pathname === "/utility" ? "active-link" : ""}>Utility</Link></li>
          <li><Link to="/roadmap" onClick={toggleMenu} className={location.pathname === "/roadmap" ? "active-link" : ""}>Roadmap</Link></li>
          <li><Link to="/art" onClick={toggleMenu} className={location.pathname === "/art" ? "active-link" : ""}>Art</Link></li>
          <li><Link to="/about" onClick={toggleMenu} className={location.pathname === "/about" ? "active-link" : ""}>About</Link></li>
          <li><Link to="/imagegeneratorai" onClick={toggleMenu} className={location.pathname === "/imagegeneratorai" ? "active-link" : ""}>Summon the Vision</Link></li>
          <li><Link to="/chatwhithai" onClick={toggleMenu} className={location.pathname === "/chatwhithai" ? "active-link" : ""}>Ask the legion</Link></li>
        </ul>

        {/* ✅ شبکه‌های اجتماعی */}
        <div className="nav-right">
          <a href="https://x.com/darkmonadnft" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaTwitter />
          </a>
          <a href="https://discord.gg/darkmonad" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaDiscord />
          </a>

          {/* ✅ پروفایل در دسکتاپ */}
          <div className="user-profile">
            {user ? (
              <>
                <img src={user.avatar} alt="User Avatar" className="user-avatar" />
                <Link to="/setting" className={location.pathname === "/setting" ? "active-link" : ""}>
                  {user.username}
                </Link>
              </>
            ) : (
              <Link to="/login" className="auth-btn">
                Register / Login
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
